export interface DetailedBullet {
  title: string
  detail: string
}

export interface Bonus {
  id: string
  title: string
  subtitle: string
  /** Reference value in USD cents, shown struck through next to "Included free" */
  referenceValueCents?: number
  intro?: string
  bulletsIntro?: string
  bullets?: string[]
  detailedBullets?: DetailedBullet[]
  secondaryBulletsIntro?: string
  secondaryBullets?: string[]
  secondaryNote?: string
  systemLabel?: string
  system?: string
  result?: string
  closing?: string[]
}

export const bonuses: Bonus[] = [
  {
    id: '01',
    title: 'Cocktail Spec Cards & Recipe Sheets',
    subtitle: 'Every Drink Laid Out the Same Professional Way',
    referenceValueCents: 14990,
    intro:
      'Printable cocktail spec cards and recipe sheets: classic and modern cocktails laid out the same way every time, plus drink-family overviews and blank templates so students can write and test their own recipes.',
    bulletsIntro: 'Includes:',
    bullets: [
      'Glass, ice & method on every card',
      'Ingredients in ml and oz',
      'Garnish & flavor profile',
      'Teaching notes for each drink',
      'Sours & highballs family sheets',
      'Old fashioneds & martinis sheets',
      'Fizzes & flips family sheets',
      'Blank spec templates',
      'Ready for classes, staff training & the back bar',
    ],
    result: 'Give students a clear, consistent reference for every drink they learn.',
  },
  {
    id: '02',
    title: 'Bar Service Lesson Scripts',
    subtitle: 'Run a Polished Service Class Without Preparing From Scratch',
    referenceValueCents: 9990,
    intro:
      'Word-for-word lesson scripts for teaching professional bar service, with talking points, demonstration steps, student practice and a quick check in each one.',
    bulletsIntro: 'Includes:',
    bullets: [
      'Greeting & reading guests',
      'Taking orders',
      'Building drinks in the right order',
      'Speed & accuracy behind the bar',
      'Handling rushes',
      'Recommending cocktails',
      'Checking ID & recognizing intoxication',
      'Refusing service politely & closing the station',
    ],
    result: 'Teach service with the confidence of a script that already works.',
  },
  {
    id: '03',
    title: 'Bar Station Training Drills',
    subtitle: 'Keep Every Session Active, Practical and Safe',
    referenceValueCents: 7990,
    intro:
      'Short, ready-to-run drills for bartending classes and bar teams, each with timing (2–15 minutes), materials, setup, steps and easy / standard / advanced variations — using water and colored practice liquids.',
    bulletsIntro: 'Includes:',
    bullets: [
      'Jigger accuracy rounds',
      'Shaking & stirring timing',
      'Double-straining practice',
      'Ice handling & garnish prep races',
      'Station setup & breakdown',
      'Two- and four-drink builds',
      'Mock-rush service simulations',
    ],
    result: 'Fill every class with practice that moves students forward.',
  },
  {
    id: '04',
    title: 'Jigger, Free-Pour & Speed Practice Cards',
    subtitle: 'Build Precision, Consistency and Speed Without Wasting Product',
    referenceValueCents: 6990,
    intro:
      'Printable practice cards to build accuracy and speed behind the bar, each with the setup, the target, the scoring method and easy / standard / advanced versions.',
    bulletsIntro: 'Includes:',
    bullets: [
      'Jigger calibration rounds',
      'Free-pour count training',
      'Measured-pour tests in ml and oz',
      'Two-hand building drills',
      'Ticket-rush sequences',
      'Weekly progress logs',
      'Pre-shift practice routines',
    ],
    result: 'Help students pour with precision and work with real bar speed.',
  },
  {
    id: '05',
    title: 'Bartending Skills Assessment Rubrics & Certificates',
    subtitle: 'Evaluate Students Objectively and Reward Every Level Achieved',
    referenceValueCents: 5990,
    intro:
      'Ready-to-use assessment rubrics for bartending and mixology courses, each scored on clear beginner, standard and advanced criteria, plus practical exam checklists, progress trackers and elegant completion certificates.',
    bulletsIntro: 'Includes:',
    bullets: [
      'Station setup rubric',
      'Measuring accuracy rubric',
      'Shake, stir & strain rubric',
      'Classic cocktail specs rubric',
      'Garnish & presentation rubric',
      'Speed of service & guest interaction',
      'Responsible alcohol service rubric',
      'Progress trackers & certificates by level',
    ],
    result: 'Assess every student fairly and celebrate every level they reach.',
  },
]
